import { Field, ID, InputType } from 'type-graphql'
import type { Adjustment } from '../Adjustment'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class FulfillAdjustmentArgs extends ActionArgs {
  @Field(() => ID)
  adjustmentId: string

  @Field(() => String)
  remarks?: string

  @Field(() => [String])
  tags?: string[]
}

export interface IFulfillAdjustment extends IAction<Adjustment, FulfillAdjustmentArgs> {}
